module.exports = __webpack_public_path__ + "static/media/position_comparison.2790c7a3.mp4";